import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面走丢了 | 网报吃瓜"
        description="抱歉，你访问的页面不存在或已被移动。返回首页或热议广场，继续围观正在被讨论的热点。"
        keywords="网报吃瓜,页面不存在"
        path="/"
      />
      <Navbar />
      <main className="pt-16 md:pt-20 min-h-[72vh] flex items-center justify-center bg-background-50">
        <div className="relative text-center px-4">
          <span className="font-heading text-[6rem] md:text-[10rem] font-black text-background-200 leading-none select-none">
            404
          </span>
          <div className="relative z-10 -mt-6">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">这一瓜没找着</h1>
            <p className="mt-3 text-sm text-foreground-600">
              页面可能已经被新的讨论替代，路径：<span className="font-mono text-foreground-500">{location.pathname}</span>
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                回到首页
              </Link>
              <Link
                to="/topics"
                className="px-6 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                去热议广场
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}